/**
 *  ===================================
 *      Script - Test
 *  ===================================
 */

class testDiscac {
  constructor() {
    this.arrayQuestions = [];
    this.currentQuestion = 0;
    this.score = 0;
    this.acfArray = [];
    this.init();
  }
  init() {
    // On récupère le nombre de questions
    const nbQuestions =
      // document.querySelector(".entry-content").dataset.questions;
      4;
    // on créer un array avec le nombre de questions
    const arrayQuestions = Array.from(Array(parseInt(nbQuestions)).keys());
    // On mélange l'array arrayQuestions
    const arrayQuestionsRandom = arrayQuestions.sort(() => Math.random() - 0.5);

    this.arrayQuestions = arrayQuestionsRandom;
    this.currentQuestion = 0;
    let dataToFetch = {
      ID: document.querySelector(".entry-content").dataset.id,
      arrayQuestions: this.arrayQuestions,
      currentQuestion: this.currentQuestion,
    };
    this.fetchApi(dataToFetch);
  }

  listenResponse() {
    const btn = document.querySelector(".btn-response");
    btn.addEventListener("click", (e) => {
      const radioResponse = document.querySelector(
        'input[name="reponse"]:checked'
      );
      if (radioResponse != null) {
        if (e.target.id === "next-question") {
          const responseID = radioResponse.value;
          this.nextQuestion(responseID);
        } else if (e.target.id === "end-test") {
          const responseID = radioResponse.value;
          this.lastQuestion(responseID);
        }
      } else {
        document.querySelector(".error").classList.remove("hidden");
      }
    });
  }
  nextQuestion(responseID) {
    this.currentQuestion++;
    let dataToFetch = {
      ID: document.querySelector(".entry-content").dataset.id,
      arrayQuestions: this.arrayQuestions,
      currentQuestion: this.currentQuestion,
      responseID: responseID,
      acfArray: this.acfArray,
    };
    this.fetchApi(dataToFetch);
  }

  lastQuestion(responseID) {
    this.currentQuestion++;
    let dataToFetch = {
      ID: document.querySelector(".entry-content").dataset.id,
      arrayQuestions: this.arrayQuestions,
      currentQuestion: this.currentQuestion,
      responseID: responseID,
      acfArray: this.acfArray,
    };
    // console.log(dataToFetch);
    this.fetchApi(dataToFetch);
  }

  fetchApi(datas) {
    fetch(discac_data.resturl + "/test", {
      method: "POST",
      body: JSON.stringify(datas),
      headers: {
        "X-WP-Nonce": discac_data.nonce,
      },
      credentials: "include",
      cache: "no-cache",
    })
      .then((response) => {
        if (response.ok) {
          return response.json(); // Convertir la réponse en JSON
        } else {
          throw new Error("Erreur lors de la requête");
        }
      })
      .then((data) => {
        // console.log(data);
        // On met à jour le score
        this.score += parseInt(data.score);
        // On récupère l'index des questions ACF
        if(data.acfArray){
          this.acfArray = data.acfArray;
        }
        if (data.html) {
          if (data.current_question.index != 0) {
            // On attennd que l'animation soit terminée
            const prevreponses = document.querySelector(
              ".slide-test__reponses"
            );
            prevreponses.classList.add("swap-go");
            prevreponses.addEventListener("transitionend", () => {
              document.querySelector(
                ".container-question .slide-test"
              ).innerHTML = data.html;
              // data.currentQuestion
              const indic = document.querySelector(
                ".slide__indic .indic[data-questionindex='" +
                  data.current_question.index +
                  "']"
              );
              indic.classList.add("active");
              const reponses = document.querySelector(".slide-test__reponses");
                //on attentend 1s puis on supprime la classe
              setTimeout(() => {
                reponses.classList.remove("swap-in");
              }, 500);
            
              this.listenResponse();
            });
          } else {
            document.querySelector(
              ".container-question .slide-test"
            ).innerHTML = data.html;
            // data.currentQuestion
            const indic = document.querySelector(
              ".slide__indic .indic[data-questionindex='" +
                data.current_question.index +
                "']"
            );
            indic.classList.add("active");
            const reponses = document.querySelector(".slide-test__reponses");
            reponses.classList.remove("swap-in");

            this.listenResponse();
          }
        } else if (data.end) {
          // console.log("score =" + this.score);
          document.querySelector(".container-question").classList.add("hidden");
          let eventName;
          if (this.score >= 2) {
            document.querySelector(".compatible").classList.remove("hidden");
            eventName = 'vue_page_felicitation_test_disca';
          } else {
            document.querySelector(".incompatible").classList.remove("hidden");
            eventName = 'vue_page_dommage_test_disca';
          }
          this.pushDataLayer(eventName);
        }
      })
      .catch((error) => console.error(error));
  }

  pushDataLayer(eventName){
    dataLayer.push({
      'event': eventName,
      'eventCategory': 'test',
      'eventAction': 'resultat'
    });
  }
}

const pageTest = document.querySelector(".single-test");
if (pageTest) {
  const appTest = new testDiscac();
  // appTest.listenResponse();
}
